import { CardElement, ElementsConsumer } from '@stripe/react-stripe-js'
import React, { useState } from 'react'
import { Button, Space, Alert } from 'antd'
import { useDispatch } from 'react-redux';
import { attachPaymentMethod } from '../../business/actions/customerActions';
import ApiManager from '../../business/services/ApiManager';
import { mutate } from 'swr';

export const CheckoutForm = (props: any) => {
  const [error, setError] = useState<string | undefined>(undefined)
  const dispatch = useDispatch();

  // @ts-ignore
  const handleSubmit = async event => {
    // Block native form submission.
    event.preventDefault()
    // @ts-ignore
    const { stripe, elements } = props

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return
    }

    // Get a reference to a mounted CardElement. Elements knows how
    // to find your CardElement because there can only ever be one of
    // each type of element.
    const cardElement = elements.getElement(CardElement)

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement
    })

    if (error) {
      setError(error.message)
      console.log('[error]', error)
    } else {
      dispatch(attachPaymentMethod.request(paymentMethod.id))
      console.log('[PaymentMethod]', paymentMethod)
    }
  }

  // @ts-ignore
  const { stripe } = props
  return (
    <form onSubmit={handleSubmit}>
      <Space
        style={{ width: '300px', padding: '5px' }}
        direction="vertical"
      >
        <CardElement
          options={{
            style: {
              base: {
                fontSize: '16px',
                color: '#424770',
                '::placeholder': {
                  color: '#aab7c4'
                }
              },
              invalid: {
                color: '#9e2146'
              }
            }
          }}
        />
        {error && <Alert
          message="Erreur"
          style={{ marginTop: '25px' }}
          description={error}
          type="error"
          showIcon
        />}
        <Button
          style={{ marginTop: '25px', float: 'right' }}
          htmlType="submit"
          disabled={!stripe}
        >
          Ajouter
                </Button>
      </Space>
    </form>
  )
}

export const InjectedCheckoutForm = () => {
  return (
    <ElementsConsumer>
      {({ elements, stripe }) => (
        // @ts-ignore
        <CheckoutForm elements={elements} stripe={stripe} />
      )}
    </ElementsConsumer>
  )
}
